import React, { useEffect, useState } from 'react';
import { getSurveyQuestions, setSurvey } from '../../Services/arndAPI';
import Loader from '../../Components/Loader/Loader';
import styles from './Styles/Survey.module.css';

export default function Survey() {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const data = await getSurveyQuestions();
      setQuestions(data);
    } catch {
      setStatus('Error loading survey questions');
    } finally {
      setLoading(false);
    }
  };

  // Editing logic
  const handleQuestionChange = (idx, value) => {
    setQuestions(prev => prev.map((q, i) => i === idx ? { ...q, question: value } : q));
  };

  const handleAnswerOptionChange = (qIdx, optIdx, value) => {
    setQuestions(prev => prev.map((q, i) =>
      i === qIdx
        ? { ...q, answerOptions: q.answerOptions.map((opt, j) => j === optIdx ? value : opt) }
        : q
    ));
  };

  const handleAddQuestion = () => {
    setQuestions(prev => [...prev, { question: '', answerOptions: [''] }]);
  };

  const handleRemoveQuestion = (idx) => {
    setQuestions(prev => prev.filter((_, i) => i !== idx));
  };

  const handleAddAnswerOption = (qIdx) => {
    setQuestions(prev => prev.map((q, i) =>
      i === qIdx ? { ...q, answerOptions: [...q.answerOptions, ''] } : q
    ));
  };

  const handleRemoveAnswerOption = (qIdx, optIdx) => {
    setQuestions(prev => prev.map((q, i) =>
      i === qIdx
        ? { ...q, answerOptions: q.answerOptions.filter((_, j) => j !== optIdx) }
        : q
    ));
  };

  const handleSaveSurvey = async () => {
    setLoading(true);
    setStatus('');
    try {
      await setSurvey(questions);
      setStatus('Survey questions saved!');
      setEditMode(false);
      fetchQuestions();
    } catch (err) {
      setStatus(err.message || 'Error saving survey questions');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2>Survey Questions</h2>
      {loading && <Loader />}
      {!loading && (
        <>
          {!editMode ? (
            <>
              <div className={styles.form}>
                {questions.length === 0 && <div>No survey questions found.</div>}
                {questions.map((q, idx) => (
                  <div key={idx} className={styles.questionBlock}>
                    <div className={styles.label}><strong>Q{idx + 1}:</strong> {q.question}</div>
                    <ul>
                      {q.answerOptions.map((opt, j) => (
                        <li key={j}>{opt}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <button className={styles.submitBtn} onClick={() => setEditMode(true)}>Edit Survey</button>
            </>
          ) : (
            <form className={styles.form} onSubmit={e => { e.preventDefault(); handleSaveSurvey(); }}>
              {questions.map((q, idx) => (
                <div key={idx} className={styles.questionBlock}>
                  <input
                    type="text"
                    value={q.question}
                    onChange={e => handleQuestionChange(idx, e.target.value)}
                    placeholder={`Question ${idx + 1}`}
                    className={styles.select}
                    required
                  />
                  <div>
                    {q.answerOptions.map((opt, j) => (
                      <div key={j} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.3rem' }}>
                        <input
                          type="text"
                          value={opt}
                          onChange={e => handleAnswerOptionChange(idx, j, e.target.value)}
                          placeholder={`Answer Option ${j + 1}`}
                          className={styles.select}
                          required
                        />
                        <button type="button" onClick={() => handleRemoveAnswerOption(idx, j)} style={{ color: '#dc2626', border: 'none', background: 'none', cursor: 'pointer' }}>Remove</button>
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => handleAddAnswerOption(idx)}
                      className={styles.addOptionBtn}
                    >
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem' }}>
                        <svg width="16" height="16" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" /></svg>
                        Add Option
                      </span>
                    </button>
                  </div>
                  <button type="button" onClick={() => handleRemoveQuestion(idx)} style={{ color: '#dc2626', border: 'none', background: 'none', cursor: 'pointer', marginTop: '0.5rem' }}>Remove Question</button>
                </div>
              ))}
              <button type="button" className={styles.submitBtn} onClick={handleAddQuestion} >Add Question</button>
              <button type="submit" className={styles.submitBtn} >Save Survey</button>
              <button type="button" className={styles.submitBtn} onClick={() => { setEditMode(false); fetchQuestions(); }}>Cancel</button>
            </form>
          )}
          {status && <div className={styles.status}>{status}</div>}
        </>
      )}
    </div>
  );
}
